import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/context/LanguageContext';

export const CTASection = () => {
    const { t } = useLanguage();

    return (
        <section className="py-24 section-cream">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                {/* Decorative Element */}
                <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-primary mb-8">
                    <span className="font-display font-bold text-2xl text-primary-foreground">
                        GM
                    </span>
                </div>

                <h2 className="font-display text-4xl sm:text-5xl font-bold text-foreground mb-6">
                    {t('home.cta.title')}
                </h2>
                <p className="text-muted-foreground text-lg sm:text-xl max-w-2xl mx-auto mb-10 leading-relaxed">
                    {t('home.cta.description')}
                </p>

                <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                    <Link to="/apply">
                        <Button 
                            size="lg"
                            className="btn-premium px-8 py-6 text-lg font-semibold rounded-lg text-primary hover:text-primary group"
                        >
                            <span className="flex items-center gap-2">
                                {t('home.cta.applyNow')}
                                <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
                            </span>
                        </Button>
                    </Link>
                    <Link to="/committees">
                        <Button 
                            variant="outline"
                            size="lg"
                            className="px-8 py-6 text-lg font-semibold rounded-lg border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground"
                        >
                            {t('home.cta.viewCommittees')}
                        </Button>
                    </Link>
                </div>

                {/* Trust Indicator */}
                <p className="mt-10 text-sm text-muted-foreground">
                    <span className="text-accent font-semibold">{t('home.cta.applicationNote')}</span>
                </p>
            </div>
        </section>
    );
};

export default CTASection;
